<aside class="sidebar">
  <!-- Logo -->
  <div class="sidebar-logo">
    <div class="logo-icon">
      <img src="assets/icons/heart-pulse-0E7A7D.svg" alt="DoctorCity" width="18" height="18">
    </div>
    <span class="logo-text">DoctorCity</span>
    <span class="logo-badge">Admin</span>
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav">
    @for (group of navGroups; track group.label) {
      <div class="nav-group">
        <div class="nav-group-header">
          <img [src]="groupIconSrc(group.icon)" alt="" width="13" height="13">
          <span>{{ group.label }}</span>
        </div>

        @for (item of group.items; track item.label) {
          <button
            class="nav-item"
            [class.active]="isActive(item.route)"
            (click)="navigate(item.route)"
            [title]="item.label"
          >
            <img
              [src]="iconSrc(item.icon, isActive(item.route))"
              alt=""
              width="14"
              height="14"
              class="nav-icon"
            >
            <span class="nav-label">{{ item.label }}</span>
          </button>
        }
      </div>
    }
  </nav>

  <!-- Footer: user info + logout -->
  <div class="sidebar-footer">
    @if (userData) {
      <div class="sidebar-user">
        <div class="user-avatar">
          @if (userData.avatarUrl) {
            <img [src]="userData.avatarUrl" alt="" class="avatar-img">
          } @else {
            <span class="avatar-initials">{{ (userData.name || userData.email || '?')[0].toUpperCase() }}</span>
          }
        </div>
        <div class="user-info">
          <div class="user-name">{{ userData.name || 'Quản trị viên' }}</div>
          <div class="user-email">{{ userData.email }}</div>
        </div>
        <button class="logout-btn" (click)="signOut()" title="Đăng xuất">
          <img src="assets/icons/log-out-6E7570.svg" alt="Đăng xuất" width="15" height="15">
        </button>
      </div>
    }
  </div>
</aside>
